import { createReducer } from '@reduxjs/toolkit';
import { closeModal, openModal } from 'redux/actions/actions';
import { modalInit } from 'redux/reducers/init';

const modal = createReducer(modalInit, {
  [openModal.type]: (state, action) => {
    const { body } = action.payload;
    state.isOpen = true;
    state.body = body;
  },
  [closeModal.type]: (state, action) => {
    state.isOpen = false;
    state.body = null;
  },
});

export default modal;
